(function () {
  const combos = document.querySelectorAll('.combo');
  const qtyVal = document.getElementById('qty-val');
  const qtyUp = document.getElementById('qty-up');
  const qtyDown = document.getElementById('qty-down');
  const addBtn = document.getElementById('add-to-cart');
  const addPrice = document.getElementById('add-price');
  const drawer = document.getElementById('drawer');
  const drawerBg = document.getElementById('drawer-bg');
  const openCartBtn = document.getElementById('open-cart');
  const closeCartBtn = document.getElementById('close-cart');
  const drawerBody = document.getElementById('drawer-body');
  const cartTotal = document.getElementById('cart-total');
  const cartSave = document.getElementById('cart-save');
  const cartPip = document.getElementById('cart-pip');
  const flash = document.getElementById('flash');
  const checkoutBtn = document.querySelector('.checkout');

  if (!addBtn) return;

  let qty = 1;
  let selected = document.querySelector('.combo.selected') || combos[0];
  if (selected && !selected.classList.contains('selected')) selected.classList.add('selected');

  const fmt = (n) => 'RM' + Number(n).toLocaleString('en-MY');
  const cartAddUrl = (window.routes && window.routes.cart_add) || '/cart/add.js';
  const cartUrl = (window.routes && window.routes.cart) || '/cart.js';

  function selectCombo(el) {
    combos.forEach((c) => c.classList.remove('selected'));
    el.classList.add('selected');
    selected = el;
    updateAddPrice();
  }
  combos.forEach((c) => c.addEventListener('click', () => selectCombo(c)));

  function updateAddPrice() {
    if (!selected) return;
    const p = +selected.dataset.price * qty;
    addPrice.textContent = fmt(p);
  }
  if (qtyUp) qtyUp.addEventListener('click', () => { qty = Math.min(qty + 1, 10); qtyVal.textContent = qty; updateAddPrice(); });
  if (qtyDown) qtyDown.addEventListener('click', () => { qty = Math.max(qty - 1, 1); qtyVal.textContent = qty; updateAddPrice(); });

  function openDrawer() { drawer.classList.add('open'); drawerBg.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { drawer.classList.remove('open'); drawerBg.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  if (openCartBtn) openCartBtn.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); refreshCart(); });
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeDrawer);
  if (drawerBg) drawerBg.addEventListener('click', closeDrawer);

  function showFlash() { flash.classList.add('show'); setTimeout(() => flash.classList.remove('show'), 1600); }

  function priceFromCents(cents) { return Math.round(cents / 100); }

  async function refreshCart() {
    try {
      const r = await fetch(cartUrl, { headers: { 'Accept': 'application/json' } });
      const cart = await r.json();
      renderCart(cart);
    } catch (e) {
      console.error('cart fetch failed', e);
    }
  }

  function renderCart(cart) {
    const items = (cart && cart.items) || [];
    if (items.length === 0) {
      drawerBody.innerHTML = '<div class="empty"><div class="moon-ico"></div><h3 style="font-family:Fraunces,serif;font-size:22px;color:var(--ink);margin-bottom:6px">Your cart is quiet.</h3><p style="font-size:14px">Pick a plan below to start your nights right.</p></div>';
    } else {
      drawerBody.innerHTML = items.map((it, i) => {
        const img = it.image || it.featured_image && it.featured_image.url || '';
        const price = priceFromCents(it.final_line_price);
        const sub = it.variant_title || it.product_title;
        return '<div class="cart-item" data-key="' + it.key + '">' +
          '<div class="thumb"><img src="' + img + '" alt=""/></div>' +
          '<div>' +
            '<div class="ci-title">' + it.product_title + '</div>' +
            '<div class="ci-sub">' + (sub || '') + '</div>' +
            '<div class="ci-qty"><button data-act="minus" data-key="' + it.key + '">−</button><span>' + it.quantity + '</span><button data-act="plus" data-key="' + it.key + '">+</button></div>' +
          '</div>' +
          '<div style="text-align:right">' +
            '<span class="ci-price">' + fmt(price) + '</span>' +
            '<span class="ci-rm" data-act="remove" data-key="' + it.key + '">Remove</span>' +
          '</div>' +
        '</div>';
      }).join('');
      drawerBody.querySelectorAll('[data-act]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          const key = btn.dataset.key;
          const act = btn.dataset.act;
          const item = items.find((x) => x.key === key);
          if (!item) return;
          let newQty = item.quantity;
          if (act === 'plus') newQty = item.quantity + 1;
          else if (act === 'minus') newQty = item.quantity - 1;
          else if (act === 'remove') newQty = 0;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          });
          refreshCart();
        });
      });
    }
    const total = priceFromCents(cart.total_price || 0);
    const original = priceFromCents(cart.original_total_price || cart.items_subtotal_price || 0);
    cartTotal.textContent = fmt(total);
    cartSave.textContent = fmt(Math.max(0, original - total));
    if (cartPip) cartPip.textContent = cart.item_count || 0;
  }

  if (addBtn) addBtn.addEventListener('click', async () => {
    if (!selected) return;
    const variantId = selected.dataset.variantId;
    if (!variantId) { console.error('No variant id on combo'); return; }
    addBtn.disabled = true;
    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('add to cart failed', err);
        alert((err && err.description) || 'Could not add to cart');
        return;
      }
      await refreshCart();
      showFlash();
      setTimeout(openDrawer, 250);
    } finally {
      addBtn.disabled = false;
    }
  });

  if (checkoutBtn) checkoutBtn.addEventListener('click', () => { window.location.href = '/checkout'; });

  // FAQ
  document.querySelectorAll('.faq-item').forEach((item) => {
    item.querySelector('.faq-q').addEventListener('click', () => {
      const open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach((i) => {
        i.classList.remove('open');
        i.querySelector('.faq-a').style.maxHeight = '0px';
      });
      if (!open) {
        item.classList.add('open');
        const a = item.querySelector('.faq-a');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  // Hero parallax
  const heroArt = document.querySelector('.hero-art');
  const hero = document.querySelector('.hero');
  if (heroArt && hero) {
    let ticking = false;
    function updateParallax() {
      const r = hero.getBoundingClientRect();
      const vh = window.innerHeight;
      const sy = Math.max(0, Math.min(1, -r.top / vh));
      heroArt.style.setProperty('--sy', sy.toFixed(3));
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateParallax); ticking = true; }
    }, { passive: true });
    updateParallax();
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal, .reveal-stagger, .reveal-scale').forEach((el) => io.observe(el));

  // Number counters
  const counters = document.querySelectorAll('.kpi b, .ing-stat b, .founder-stats b');
  const counterIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      counterIO.unobserve(e.target);
      const el = e.target;
      const text = el.textContent.trim();
      const m = text.match(/^([+\-]?)(\d[\d,]*)(.*)$/);
      if (!m) return;
      const sign = m[1];
      const target = parseInt(m[2].replace(/,/g, ''), 10);
      const suffix = m[3];
      if (isNaN(target)) return;
      const dur = 1100, t0 = performance.now();
      function tick(now) {
        const t = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        const val = Math.round(target * eased);
        el.textContent = sign + val.toLocaleString() + suffix;
        if (t < 1) requestAnimationFrame(tick);
      }
      el.textContent = sign + '0' + suffix;
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });
  counters.forEach((c) => counterIO.observe(c));

  // Video gallery — play overlay + arrows
  document.querySelectorAll('.vg-play').forEach((btn) => {
    btn.addEventListener('click', () => {
      const video = btn.previousElementSibling;
      if (!video) return;
      try { video.play(); } catch (e) {}
      btn.classList.add('hidden');
    });
  });
  const vgTrack = document.getElementById('vg-track');
  const vgPrev = document.querySelector('.vg-prev');
  const vgNext = document.querySelector('.vg-next');
  if (vgTrack && vgPrev && vgNext) {
    const step = () => Math.max(280, vgTrack.clientWidth * 0.85);
    vgPrev.addEventListener('click', () => vgTrack.scrollBy({ left: -step(), behavior: 'smooth' }));
    vgNext.addEventListener('click', () => vgTrack.scrollBy({ left: step(), behavior: 'smooth' }));
  }
  // Pause other videos when one starts
  document.querySelectorAll('.vg-video video').forEach((v) => {
    v.addEventListener('play', () => {
      document.querySelectorAll('.vg-video video').forEach((other) => {
        if (other !== v && !other.paused) other.pause();
      });
    });
  });

  refreshCart();
  updateAddPrice();
})();
